<template>
  <section class="ead-page">    
    <b-message v-if="erro" type="is-danger" aria-close-label="Fechar" @close="erro = ''">{{ erro }}</b-message>

    <div class="box meus-cursos-header">
      <div class="meus-cursos-header__conteudo">
        <span class="meus-cursos-header__icone">
          <b-icon icon="school-outline" />
        </span>
        <div>
          <p class="meus-cursos-header__legenda">Minha aprendizagem</p>
          <h1 class="title is-4 mb-1">Meus cursos</h1>
          <p class="has-text-grey">            
          </p>
        </div>
      </div>

      <div v-if="cursos.length" class="resumo-cursos">
        <div class="resumo-item">
          <strong>{{ resumo.total }}</strong>
          <span>Disponíveis</span>
        </div>
        <div class="resumo-item resumo-item--andamento">
          <strong>{{ resumo.emAndamento }}</strong>
          <span>Em andamento</span>
        </div>
        <div class="resumo-item resumo-item--concluido">
          <strong>{{ resumo.concluidos }}</strong>
          <span>Concluídos</span>
        </div>
        <div v-if="resumo.atrasados" class="resumo-item resumo-item--atrasado">
          <strong>{{ resumo.atrasados }}</strong>
          <span>Em atraso</span>
        </div>
      </div>
    </div>

    <div v-if="cursos.length" class="box cursos-filtros">
      <div class="busca-cursos">
        <b-input
          v-model="busca"
          icon="magnify"
          :icon-right="busca ? 'close-circle' : null"
          icon-right-clickable
          placeholder="Buscar nos meus cursos"
          @icon-right-click="busca = ''"
        />
      </div>
      <div class="filtros-status" role="group" aria-label="Filtrar cursos">
        <button
          v-for="opcao in filtros"
          :key="opcao.valor"
          type="button"
          class="button filtro-button"
          :class="{ 'is-primary': filtro === opcao.valor }"
          @click="filtro = opcao.valor"
        >
          {{ opcao.texto }}
          <span class="filtro-contador">{{ quantidadeFiltro(opcao.valor) }}</span>
        </button>
      </div>
    </div>

    <div v-if="loading" class="carregando-cursos">
      <b-loading :active="loading" :is-full-page="false" />
    </div>

    <div v-else-if="!cursos.length" class="box estado-vazio">
      <span class="estado-vazio__icone">
        <b-icon icon="book-open-page-variant" size="is-large" />
      </span>
      <h2 class="title is-5 mb-2">Nenhum curso disponível</h2>
      <p class="has-text-grey">
        Quando um treinamento for liberado para você, ele aparecerá nesta tela.
      </p>
    </div>

    <template v-else>
      <div v-if="cursosExibidos.length" class="columns is-multiline cursos-grid">
        <div
          v-for="curso in cursosExibidos"
          :key="curso.id"
          class="column is-4-desktop is-6-tablet"
        >
          <ead-curso-card :curso="curso" />
        </div>
      </div>

      <div v-else class="box estado-vazio estado-vazio--filtro">
        <span class="estado-vazio__icone">
          <b-icon icon="book-search-outline" size="is-large" />
        </span>
        <h2 class="title is-5 mb-2">Nenhum curso encontrado</h2>
        <p class="has-text-grey mb-4">
          Ajuste a busca ou selecione outro filtro para visualizar seus cursos.
        </p>
        <b-button icon-left="filter-remove-outline" @click="limparFiltros">
          Limpar filtros
        </b-button>
      </div>
    </template>
  </section>
</template>

<script>
import http from '@/http'
import EadCursoCard from '@/components/ead/ead-curso-card.vue'

export default {
  name: 'EadMeusCursos',
  components: { EadCursoCard },
  data: () => ({
    cursos: [],
    loading: false,
    erro: '',
    busca: '',
    filtro: 'todos',
    filtros: [
      { valor: 'todos', texto: 'Todos' },
      { valor: 'andamento', texto: 'Em andamento' },
      { valor: 'concluidos', texto: 'Concluídos' },
      { valor: 'atrasados', texto: 'Em atraso' },
    ],
  }),
  computed: {
    resumo() {
      return {
        total: this.cursos.length,
        emAndamento: this.cursos.filter((curso) =>
          this.correspondeFiltro(curso, 'andamento')
        ).length,
        concluidos: this.cursos.filter((curso) =>
          this.correspondeFiltro(curso, 'concluidos')
        ).length,
        atrasados: this.cursos.filter((curso) =>
          this.correspondeFiltro(curso, 'atrasados')
        ).length,
      }
    },
    cursosExibidos() {
      const termo = this.busca.trim().toLocaleLowerCase('pt-BR')
      return this.cursos.filter((curso) => {
        const correspondeBusca =
          !termo ||
          `${curso.nome || ''} ${curso.descricao || ''}`
            .toLocaleLowerCase('pt-BR')
            .includes(termo)
        return correspondeBusca && this.correspondeFiltro(curso, this.filtro)
      })
    },
  },
  mounted() {
    this.carregar()
  },
  methods: {
    carregar() {
      this.loading = true
      this.erro = ''
      http
        .get('/api/ead-aprendizagem/meus-cursos')
        .then((r) => {
          this.cursos = (r.data || []).filter(
            (curso) => curso.status !== 'BLOQUEADO'
          )
        })
        .catch((e) => {
          this.cursos = []
          this.erro = e && e.data && e.data.erro ? e.data.erro : 'Não foi possível carregar seus cursos.'
        })
        .finally(() => {
          this.loading = false
        })
    },
    correspondeFiltro(curso, filtro) {
      if (filtro === 'andamento') return curso.status === 'EM_ANDAMENTO'
      if (filtro === 'concluidos') return curso.status === 'CONCLUIDO'
      if (filtro === 'atrasados') return curso.atrasado
      return true
    },
    quantidadeFiltro(filtro) {
      return this.cursos.filter((curso) => this.correspondeFiltro(curso, filtro))
        .length
    },
    limparFiltros() {
      this.busca = ''
      this.filtro = 'todos'
    },
  },
}
</script>

<style scoped>
.ead-page {
  min-height: 100%;
  position: relative;
}

.meus-cursos-header,
.meus-cursos-header__conteudo,
.resumo-cursos,
.cursos-filtros,
.filtros-status,
.filtro-button {
  align-items: center;
  display: flex;
}

.meus-cursos-header {
  border-left: 4px solid #00b89c;
  gap: 1.5rem;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}

.meus-cursos-header__conteudo {
  gap: 0.85rem;
}

.meus-cursos-header__icone,
.estado-vazio__icone {
  align-items: center;
  background: rgba(0, 184, 156, 0.11);
  border-radius: 50%;
  color: #008f79;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
}

.meus-cursos-header__icone {
  height: 3rem;
  width: 3rem;
}

.meus-cursos-header__legenda {
  color: #7a7a7a;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
}

.resumo-cursos {
  flex: 0 0 auto;
  gap: 0.5rem;
}

.resumo-item {
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 7px;
  min-width: 88px;
  padding: 0.55rem 0.75rem;
  text-align: center;
}

.resumo-item strong,
.resumo-item span {
  display: block;
}

.resumo-item strong {
  color: #363636;
  font-size: 1.1rem;
}

.resumo-item span {
  color: #7a7a7a;
  font-size: 0.68rem;
}

.resumo-item--andamento {
  border-color: rgba(32, 156, 238, 0.3);
}

.resumo-item--concluido {
  border-color: rgba(0, 184, 156, 0.35);
}

.resumo-item--atrasado {
  border-color: rgba(241, 70, 104, 0.35);
}

.cursos-filtros {
  background: #fafafa;
  border: 1px solid #ededed;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}

.busca-cursos {
  max-width: 420px;
  width: 100%;
}

.filtros-status {
  flex-wrap: wrap;
  gap: 0.4rem;
  justify-content: flex-end;
}

.filtro-button {
  border-color: #e5e5e5;
  gap: 0.45rem;
}

.filtro-contador {
  align-items: center;
  background: rgba(0, 0, 0, 0.07);
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.7rem;
  height: 1.35rem;
  justify-content: center;
  min-width: 1.35rem;
  padding: 0 0.3rem;
}

.filtro-button.is-primary .filtro-contador {
  background: rgba(255, 255, 255, 0.22);
}

.carregando-cursos {
  min-height: 260px;
  position: relative;
}

.cursos-grid {
  align-items: stretch;
}

.cursos-grid > .column {
  display: flex;
}

.estado-vazio {
  align-items: center;
  border: 1px solid #ededed;
  color: #7a7a7a;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 300px;
  padding: 3rem 1rem;
  text-align: center;
}

.estado-vazio__icone {
  height: 4rem;
  margin-bottom: 1rem;
  width: 4rem;
}

.estado-vazio--filtro {
  min-height: 260px;
}

@media screen and (max-width: 1023px) {
  .meus-cursos-header,
  .cursos-filtros {
    align-items: stretch;
    flex-direction: column;
  }

  .resumo-cursos,
  .filtros-status {
    justify-content: flex-start;
  }

  .busca-cursos {
    max-width: none;
  }
}

@media screen and (max-width: 768px) {
  .meus-cursos-header__conteudo {
    align-items: flex-start;
  }

  .resumo-cursos {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .filtros-status {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .filtro-button {
    justify-content: center;
    width: 100%;
  }
}
</style>
